import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FiPlus, FiSearch, FiDownload, FiMoreHorizontal } from 'react-icons/fi';
import { FormGroup, FormControl, Dropdown } from 'react-bootstrap';
import Loading from 'components/Loading';
import Layout from 'components/Layout';
import ContractsList from 'components/Contracts';
import ContractEditDrawer from 'components/Contracts/ContractEditDrawer';
import { showModal, hideModal } from 'actions/modalActions';
import * as shiftsActions from 'actions/shiftsActions';
import * as timesActions from 'actions/timesActions';
import * as rulesActions from 'actions/rulesActions';
import Modal from 'components/Modal';
import { withTranslation } from 'react-i18next';
import HelpBanner from 'components/HelpBanner';

class Contracts extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchContract: '',
		};

		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.getContracts = this.getContracts.bind(this);
		this.openNewContractDrawer = this.openNewContractDrawer.bind(this);

		this.searchTimeout = null;
	}

	componentDidMount() {
		this.getContracts();
		this.getShifts();
		this.props.getSelectableTimeTypes();
	}

	componentWillUnmount() {
		if (this.searchTimeout) {
			clearTimeout(this.searchTimeout);
		}
	}

	handleChangeSearch = (event) => {
		this.setState(
			{
				[event.target.id]: event.target.value,
			},
			() => {
				this.debouncedGetContracts();
			}
		);
	};

	debouncedGetContracts = () => {
		if (this.searchTimeout) {
			clearTimeout(this.searchTimeout);
		}

		this.searchTimeout = setTimeout(() => {
			this.getContracts();
		}, 500);
	};

	async getContracts() {
		await this.props.getContracts({
			q: this.state.searchContract,
			variant: 'detailed',
		});
	}

	async getShifts() {
		// TODO fer una sola crida i filtrar per JS
		await this.props.getSelectableShifts();
		await this.props.getAttendanceShifts();
		await this.props.getNonAttendanceShifts();
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewContractDrawer() {
		this.props.showModal(
			{
				open: true,
				width: 1000,
				content: ({ close, registerBeforeClose }) => (
					<ContractEditDrawer
						getContracts={this.getContracts}
						handleClose={close}
						registerBeforeClose={registerBeforeClose}
					/>
				),
				closeModal: this.closeModal,
			},
			'drawer'
		);
	}

	getContent = () => {
		if (this.props.loading) {
			return <Loading />;
		}

		if (!this.props.accounts) {
			return this.props.t('contracts.errorLoading');
		}

		return <ContractsList />;
	};

	render() {
		return (
			<>
				<Layout configSidebar={true} className="page-contracts" context="rules">
					<div className="heading">
						<h1 className="title">{this.props.t("contracts.title")}</h1>
						<div className="heading-help-banner heading-config hidden-sm">
							<HelpBanner
								title={this.props.t("common.needHelp")}
								text={this.props.t("common.helpText")}
								linkText={this.props.t("common.moreInfo")}
								linkHref="https://help.plain.ninja/es/collections/12643122-contratos"
							/>
						</div>
						<div className="heading-filters">
							<FormGroup
								className="form-group form-search"
								controlId="searchContract"
							>
								<FormControl
									type="text"
									placeholder={this.props.t("common.searchPlaceholder")}
									value={this.state.searchContract}
									onChange={this.handleChangeSearch}
								/>
								<FiSearch />
							</FormGroup>
						</div>
						<div className="heading-actions">
							<button
								type="button"
								title={this.props.t("contracts.createContract")}
								onClick={this.openNewContractDrawer}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() => this.props.history.push('/contracts/import')}
									>
										<FiDownload className="dropdown-icon" /> {this.props.t('contracts.importContracts')}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		...reducers.timesReducer,
		...reducers.rulesReducer,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getContracts: (options) => dispatch(rulesActions.getContracts(options)),
	getSelectableShifts: () => dispatch(shiftsActions.getSelectableShifts()),
	getAttendanceShifts: () => dispatch(shiftsActions.getAttendanceShifts()),
	getNonAttendanceShifts: () =>
		dispatch(shiftsActions.getNonAttendanceShifts()),
	getSelectableTimeTypes: () => dispatch(timesActions.getSelectableTimeTypes()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Contracts));
